// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressBar_progressBar__2VjcF","fillerStyles":"ProgressBar_fillerStyles__1vp9H","labelStyles":"ProgressBar_labelStyles__iQLXD"};